import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { ScrollableContentWrapper } from './ScrollableContent.styles';
import { useScrollContainer } from './useScrollContainer';
export var ScrollableContentContext = React.createContext({
  atTop: true,
  atBottom: true,
  scroll: 0,
  height: 0
});
/**
 * ScrollableContent
 */

export var ScrollableContent = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _useScrollContainer = useScrollContainer(),
      atTop = _useScrollContainer.atTop,
      atBottom = _useScrollContainer.atBottom,
      scroll = _useScrollContainer.scroll,
      height = _useScrollContainer.height,
      divProps = _objectWithoutProperties(_useScrollContainer, ["atTop", "atBottom", "scroll", "height"]);

  return /*#__PURE__*/React.createElement(ScrollableContentContext.Provider, {
    value: {
      atTop: atTop,
      atBottom: atBottom,
      scroll: scroll,
      height: height
    }
  }, /*#__PURE__*/React.createElement(ScrollableContentWrapper, Object.assign({}, props, {
    moreTop: !atTop,
    moreBottom: !atBottom,
    ref: ref
  }), /*#__PURE__*/React.createElement("div", divProps, children)));
});